import React from 'react'
import img1 from './images/usecaseImg1.svg';
import img2 from './images/usecaseImg2.svg';
import img3 from './images/usecaseImg3.svg';
import img4 from './images/usecaseImg4.svg';
import img5 from './images/usecaseImg5.svg';
import img6 from './images/usecaseImg6.svg';
import img7 from './images/usecaseImg7.svg';
import img8 from './images/usecaseImg8.svg';

const Usecases = () => {
    const cards = [
        {
            icon: img1,
            title: 'Placing Orders',
            desc:
                'Collect product choices, quantities, and delivery preferences through the form. Add payments for a complete checkout.',
        },
        {
            icon: img2,
            title: 'Event Registration',
            desc:
                'Capture attendee details, confirm registration, and send event info directly via WhatsApp.',
        },
        {
            icon: img3,
            title: 'Booking Appointments',
            desc:
                'Gather name, contact, and preferred time. Auto-confirm appointments through WhatsApp.',
        },
        {
            icon: img4,
            title: 'Restaurant Reservations',
            desc:
                'Collect date, time, and party size. Confirm and manage reservations automatically.',
        },
        {
            icon: img5,
            title: 'Gathering Client Feedback',
            desc:
                'Request ratings and comments. Automate collection and analysis to improve services.',
        },
        {
            icon: img6,
            title: 'Quotation Request',
            desc:
                'Capture requirements (size, quantity, notes) and share tailored quotes for any scenario.',
        },
        {
            icon: img7,
            title: 'General Contact Form',
            desc:
                'Collect contact info and the purpose of inquiry. Auto-acknowledge and route to the right team.',
        },
        {
            icon: img8,
            title: 'Travel Booking',
            desc:
                'Simplify itineraries and support with WhatsApp Flow’s intuitive booking features.',
        },
    ];

    return (
        <section className="py-4 position-relative" style={{ overflow: 'hidden' }}>
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{ maxWidth: '88%', zIndex: 1, marginTop: 60 }}
            >
                {/* Row: left copy + right cards */}
                <div className="uc-row">
                    {/* LEFT SIDE (kept your heading styles) */}
                    <div className="uc-left">
                        <h2
                            style={{
                                fontSize: '2.5rem',
                                fontFamily: 'Inter',
                                fontWeight: 700,
                                color: '#242121ff',
                                lineHeight: 1.2,
                                margin: 0,
                            }}
                        >
                            <span style={{ color: '#1DB954' }}>WhatsApp</span> Forms
                            <br />
                            Use-Cases
                        </h2>

                        <p
                            className="mt-2"
                            style={{
                                marginTop: 6,
                                color: '#413e3eff',
                                fontSize: '1.1rem',
                                fontFamily: 'Poppins',
                                fontWeight: 300,
                                lineHeight: 1.4,
                                maxWidth: 400,
                            }}
                        >
                            Here’s how you can effectively use a WhatsApp Lead Generation
                            Form for different scenarios:
                        </p>

                        <button type="button" className="uc-cta">
                            Talk to Sales <span className="uc-arrow">→</span>
                        </button>
                    </div>

                    {/* RIGHT SIDE: Cards grid */}
                    <div className="uc-right">
                        <div className="uc-grid">
                            {cards.map((c, i) => (
                                <div className="uc-card" key={i}>
                                    <div className="uc-icon">
                                        <img
                                            src={c.icon}
                                            alt=""
                                            width={26}
                                            height={26}
                                            loading="lazy"
                                            style={{ display: 'block' }}
                                        />
                                    </div>
                                    <h3 className="uc-title">{c.title}</h3>
                                    <p className="uc-desc">{c.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Styles */}
            <style>{`
        .uc-row{
          display:flex;
          align-items:flex-start;
          justify-content:space-between;
          gap:48px;
        }
        .uc-left{ 
          flex: 0 0 360px; 
        }
        .uc-right{ 
          flex: 1; 
        }

        /* CTA with soft shine */
        .uc-cta{
          margin-top: 14px;
          display:inline-flex; 
          align-items:center; gap:10px;
          padding: 12px 18px;
          border: none; 
          border-radius: 10px;
          background: #054E91; 
          color:#fff;
          font-weight: 600; 
          font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
          cursor:pointer; 
          position:relative; 
          overflow:hidden;
          transition: transform .12s ease, box-shadow .12s ease;
        }
        .uc-cta:active{ transform: translateY(1px); }
        .uc-cta::after{
          content:""; position:absolute; top:-60%; left:-50%;
          width:40%; height:220%;
          background: linear-gradient(115deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.6) 50%, rgba(255,255,255,0) 100%);
          transform: skewX(-20deg); opacity:0; pointer-events:none;
        }
        .uc-cta:hover::after{ animation: ucShine 900ms cubic-bezier(.25,.8,.25,1) forwards; opacity:1; }
        .uc-arrow{ font-weight:800; }
        @keyframes ucShine{ 0%{left:-60%;} 100%{left:120%;} }

        /* Grid + cards */
        .uc-grid{
          display:grid;
          grid-template-columns: repeat(3, minmax(240px, 1fr));
          gap: 34px 38px;
        }
        .uc-card{
          background:#fff;
          border: 0px solid #e5e7eb;
          border-radius: 12px;
          padding: 18px 18px 20px;
          box-shadow: 0 6px 14px rgba(15,23,42,0.06);
          transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease;
        }
        .uc-card:hover{
          transform: translateY(-4px);
          background:#ffffff;
          border-color: #d7dde7;
          box-shadow: 0 14px 32px rgba(15,23,42,0.14);
        }
        

        /* Icon chip look + brand color */
.uc-icon{
  width:42px; 
  height:42px; 
  border-radius:10px;
  display:flex; 
  align-items:center; 
  justify-content:center;
  background: #EEF5FF;                 
  border:1px solid #DBE7FF;          
  color: #054E91;     
  margin-bottom: 0.7rem               
}

/* If icon is inline <svg> */
.uc-icon svg{
  width:24px; height:24px;
  display:block;
}
.uc-icon svg path,
.uc-icon svg circle,
.uc-icon svg rect,
.uc-icon svg polygon,
.uc-icon svg line,
.uc-icon svg polyline{
  stroke:#054E91 !important;          /* dark blue */
  fill:#054E91;                       /* in case the SVG uses fill */
}

/* If icon is imported as <img src="*.svg"> — tint via filter */
.uc-icon img{
  width:24px; height:24px; display:block;
  /* approximate tint to #054E91 */
  filter: invert(14%) sepia(92%) saturate(950%) hue-rotate(182deg)
          brightness(92%) contrast(102%);
}

        .uc-title{
          margin:0 0 6px 0;
          font-size: 1.15rem;
          line-height: 1.35;
          font-weight: 700;
          color:#0f172a;
          font-family: Lato;
        }
        .uc-desc{
          margin:0;
          color:#334155;
          line-height:1.22;
          font-size: .98rem;
          font-family: Lato;
        }

        /* Responsive */
        @media (max-width: 1200px){
          .uc-grid{ grid-template-columns: repeat(2, minmax(240px, 1fr)); }
        }
        @media (max-width: 820px){
          .uc-row{ flex-direction:column; gap:28px; }
          .uc-left{ flex: none; }
        }
        @media (max-width: 540px){
          .uc-grid{ grid-template-columns: 1fr; }
        }
      `}</style>
        </section>
    );
};

export default Usecases;
